import ButtonMenu from "../elements/ButtonMenu";
import LogoHeader from "../elements/LogoHeader";
import DynamicNav from "../../nav/DynamicNav";
import React, { useState } from "react";
import {Link, useLocation} from "react-router-dom";

export default function Mobile() {
  const location = useLocation();
  const navLinks = [
    { src: null, url: "#section-2", text: "How it works" },
    { src: null, url: "#section-3", text: "Why choose us" },
    { src: null, url: "#section-5", text: "Pricing" },
    { src: null, url: "#section-6", text: "Security" },
  ];

  // Hide DynamicNav on login, register, and forgot-password pages
  const hiddenPaths = ['/login', '/register', '/forgot-password'];
  const shouldHideNav = hiddenPaths.some(path => location.pathname.includes(path));

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
      <div className="grid gap-2 grid-cols-3 items-center p-4 desktop:hidden">
        <div className="flex items-start justify-start">
          <ButtonMenu toggleMenu={toggleMenu} isOpen={isOpen} />
        </div>
        <LogoHeader />
      </div>

      <div
        className={`bg-white w-full h-full border p-5 ${isOpen ? "" : "hidden"}`}
      >
        <div className="flex flex-col gap-y-2 items-start justify-self-start w-full">
          {!shouldHideNav && <DynamicNav links={navLinks} navigateTo={false} />}
          <div className="flex  items-center">
            <img className="h-4 mr-2" src={`${process.env.PUBLIC_URL}/login-ico.svg`} alt="login"/>
            <a href="/login" className="text-primary">
              Login
            </a>
          </div>
          <Link to={`register`} className={`w-1/2 h-[40px] rounded-[25px] bg-secondary flex items-center justify-center`}>
            <p className={`text-white text-center`}>Create account</p>
          </Link>
        </div>
      </div>
    </>
  );
}
